import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { resetUsers, useLazyGetContactHistoriesQuery } from 'services';
import { AppDispatch } from 'store';
import { FindAllContactHistoryDto } from 'types';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useLazyContactHistories() {
  const dispatch = useDispatch<AppDispatch>();

  const [trigger, { data: dataResponse, isLoading, isFetching, originalArgs, endpointName }] =
    useLazyGetContactHistoriesQuery();

  const { rows, count } = dataResponse?.data || {};
  const hasMore = Boolean(rows && count && rows.length < count);

  const handleLoadMore = useCallback(() => {
    if (hasMore)
      trigger({
        ...originalArgs,
        isMore: true,
        pageSize,
        pageIndex: originalArgs?.pageIndex ? originalArgs?.pageIndex + 1 : DEFAULT_PAGE_INDEX
      });
  }, [hasMore, originalArgs]);

  const fetchData = useCallback((value?: Partial<FindAllContactHistoryDto>) => {
    trigger({
      pageIndex: 1,
      pageSize,
      isMore: true,

      ...originalArgs,
      ...value
    });
  }, []);

  const clearData = () => {
    if (endpointName) dispatch(resetUsers(endpointName));
  };

  return {
    data: rows || [],
    count: count || 0,
    isFetching,
    isLoading,
    handleLoadMore,
    hasMore,
    fetchData,
    endpointName,
    clearData
  };
}
